import util from './util'
import global from "./global";
import { Toast } from 'vant';

const Http = {
    request(options) {
        var host = global.DIST_API_HOST;
        if(util.isBeta()){
            host = global.DEV_API_HOST;
        }
        if(util.isUat()){
            host = global.UAT_API_HOST;
        }
        // 开发环境使用相对路径，通过 devServer proxy 代理转发到正式环境
        if(util.isDevelopment()){
            host = '/api';
        }

        options.api = (options.url || host)+'/'+options.api;
        if(options.loading){
            Toast.loading({
                overlay:true,
                duration:0
            });
        }
        var header = options.header?options.header:{};
        header.Token = options.access_token ? options.access_token : util.getAccessToken();
        header.Lang = "zh_CN";
        $.ajax({
            method: options.type ? options.type : 'POST',
            url: options.api,
            data: options.data?options.data:{},
            headers:header,
            dataType: 'json',
            async:options.async == 1 ? false : true,
            // timeout:15000,
            success:(res)=>{
                Toast.clear()
                if (res.code === 1 || res.errCode == 0) {
                    options.success(res.data);
                } else {
                    if (options.error) {
                        options.error(res)
                    }else{
                        Toast.fail(res.msg);
                    }
                }
            },
            error:(error)=>{
                Toast.clear();
                if(error.statusText !== 'error'){
                    Toast.fail("活动太火爆，请稍后再试!");
                }
                console.log(error);
            }
        })
    },
}

export default Http;
